(() => {
  const desktop = window.matchMedia('(min-width: 1025px)');
  const init = (gallery) => {
    if (gallery.dataset.krStickyReady) return;
    gallery.dataset.krStickyReady = 'true';
    const events = new AbortController();
    const options = { signal: events.signal };
    let top = 16;
    let minimum = 16;
    let maximum = 16;
    let galleryHeight = 0;
    let previewHeight = 0;
    let previousY = window.scrollY;
    let frame = 0;
    const apply = () => {
      if (desktop.matches) {
        gallery.style.setProperty('--kr-gallery-sticky-top', `${top}px`);
      } else {
        gallery.style.removeProperty('--kr-gallery-sticky-top');
      }
    };
    const bounds = () => {
      const header = document.querySelector('.section-header') || document.querySelector('header');
      const rect = header?.getBoundingClientRect();
      const visibleHeaderBottom = rect && rect.top <= 1 && rect.bottom > 0 ? rect.bottom : 0;
      maximum = 16 + visibleHeaderBottom;
      minimum = Math.min(maximum, window.innerHeight - galleryHeight - 24 - previewHeight);
    };
    const measure = () => {
      const preview = document.querySelector('iframe[src*="/preview-bar/"]');
      const rect = preview?.getBoundingClientRect();
      previewHeight = rect && rect.bottom >= window.innerHeight - 1 ? Math.min(72, rect.height) : 0;
      galleryHeight = gallery.getBoundingClientRect().height;
      bounds();
      top = desktop.matches ? Math.max(minimum, Math.min(maximum, top)) : maximum;
      previousY = window.scrollY;
      apply();
    };
    const scroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        const y = window.scrollY;
        if (desktop.matches) {
          bounds();
          const next = Math.max(minimum, Math.min(maximum, top - (y - previousY)));
          if (next !== top) {
            top = next;
            apply();
          }
        }
        previousY = y;
      });
    };
    const observer = new ResizeObserver(measure);
    observer.observe(gallery);
    window.addEventListener('scroll', scroll, { ...options, passive: true });
    window.addEventListener('resize', measure, options);
    window.addEventListener('load', measure, { ...options, once: true });
    document.querySelector('.section-header')?.addEventListener('transitionend', measure, options);
    desktop.addEventListener('change', measure, options);
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(gallery)) return;
      observer.disconnect();
      events.abort();
      if (frame) window.cancelAnimationFrame(frame);
    }, options);
    measure();
  };
  const scan = (root) => root.querySelectorAll('.product-detail__media > media-gallery.sticky').forEach(init);
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();

